import reducer from './login';
import { actionCreators, LoginActionType } from './login.actionCreators';
import * as actionTypes from './login.actionTypes';

export * from './login';
export * from './login.selectors';
export type ActionType = LoginActionType;
export { actionTypes, actionCreators };
export default reducer;
